import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import tr from './locales/tr.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import treatmentsEn from './locales/treatments-en.json';
import treatmentsTr from './locales/treatments-tr.json';
import treatmentsFr from './locales/treatments-fr.json';
import treatmentsDe from './locales/treatments-de.json';
import pagesEn from './locales/pages-en.json';
import pagesTr from './locales/pages-tr.json';
import pagesFr from './locales/pages-fr.json';
import pagesDe from './locales/pages-de.json';
import adminEn from './locales/admin-en.json';
import adminTr from './locales/admin-tr.json';
import adminFr from './locales/admin-fr.json';
import adminDe from './locales/admin-de.json';

// Custom language persistence
const LANGUAGE_KEY = 'sule-dental-language';

export const saveLanguagePreference = (language: string) => {
  try {
    localStorage.setItem(LANGUAGE_KEY, language);
  } catch (error) {
    console.error('Failed to save language preference:', error);
  }
};

export const getLanguagePreference = (): string | null => {
  try {
    return localStorage.getItem(LANGUAGE_KEY);
  } catch (error) {
    console.error('Failed to get language preference:', error);
    return null;
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { 
        translation: en,
        treatments: treatmentsEn,
        pages: pagesEn,
        admin: adminEn
      },
      tr: { 
        translation: tr,
        treatments: treatmentsTr,
        pages: pagesTr,
        admin: adminTr
      },
      fr: { 
        translation: fr,
        treatments: treatmentsFr,
        pages: pagesFr,
        admin: adminFr
      },
      de: { 
        translation: de,
        treatments: treatmentsDe,
        pages: pagesDe,
        admin: adminDe
      },
    },
    fallbackLng: 'tr',
    supportedLngs: ['tr', 'en', 'de', 'fr'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
      lookupLocalStorage: LANGUAGE_KEY,
    },
  });

export default i18n;
